import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Response} from '../models/models';
import {Translation} from '../models/translation';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(private httpClient: HttpClient) { }

  public getTranslation(languageCode: string): Observable<Response<Translation>> {
    return this.httpClient.get<Response<Translation>>(environment.apiPath + 'Translation/' + languageCode + '/LanguageCode');
  }
}
